import { Chip, ChipProps } from '@mui/material';
import type { DocumentCategory, InboundDocumentStatus, InboundFileState } from '../types';

export const CATEGORY_LABELS: Record<DocumentCategory, string> = {
  TEAM_VERIFICATION_FORM: 'Team Verification Form',
  BILL_OF_LADING: 'Bill of lading',
  SEAL_PHOTO: 'Seal photo',
  LOCK_PHOTO: 'Lock photo',
  TRAILER_PHOTO: 'Trailer photo',
  TRACTOR_PHOTO: 'Tractor photo',
  FREIGHT_PHOTO: 'Freight photo',
  DRIVER_LICENSE: 'Driver licence',
  SECURITY_PROCEDURES_FORM: 'Security procedures form',
  RATE_CONFIRMATION: 'Rate confirmation',
  TALLY_OR_RECEIPT: 'Tally / receipt',
  OTHER: 'Other',
  UNREADABLE: 'Unreadable'
};

/** Order the files are grouped in on a load: the documents that carry the key fields first. */
export const CATEGORY_ORDER: DocumentCategory[] = [
  'TEAM_VERIFICATION_FORM',
  'BILL_OF_LADING',
  'SEAL_PHOTO',
  'DRIVER_LICENSE',
  'TRAILER_PHOTO',
  'TRACTOR_PHOTO',
  'LOCK_PHOTO',
  'FREIGHT_PHOTO',
  'SECURITY_PROCEDURES_FORM',
  'RATE_CONFIRMATION',
  'TALLY_OR_RECEIPT',
  'OTHER',
  'UNREADABLE'
];

const STATUS: Record<InboundDocumentStatus, { label: string; color: ChipProps['color'] }> = {
  COMPLETE: { label: 'Complete', color: 'success' },
  INCOMPLETE: { label: 'Incomplete', color: 'warning' },
  NEEDS_REVIEW: { label: 'Needs review', color: 'error' },
  PROCESSING: { label: 'Reading…', color: 'info' }
};

export const DOCUMENT_STATUS_LABELS: Record<InboundDocumentStatus, string> = {
  COMPLETE: STATUS.COMPLETE.label,
  INCOMPLETE: STATUS.INCOMPLETE.label,
  NEEDS_REVIEW: STATUS.NEEDS_REVIEW.label,
  PROCESSING: STATUS.PROCESSING.label
};

export function DocumentStatusChip({ status }: { status: InboundDocumentStatus }) {
  const s = STATUS[status] ?? { label: status, color: 'default' as const };
  return <Chip size="small" variant="light" color={s.color} label={s.label} sx={{ fontWeight: 600 }} />;
}

export const FILE_STATE_LABELS: Record<InboundFileState, string> = {
  PENDING: 'Waiting',
  PROCESSING: 'Reading',
  DONE: 'Read',
  DUPLICATE: 'Duplicate',
  FAILED: 'Failed',
  REJECTED: 'Rejected',
  SUPERSEDED: 'Replaced'
};

/** The agreed priority fields, as stored in `missingFields`. */
export const KEY_FIELD_LABELS: Record<string, string> = {
  vendorName: 'Vendor',
  mcNumber: 'MC #',
  dotNumber: 'DOT #',
  'truck.licensePlate': 'Truck plate',
  'trailer.licensePlate': 'Trailer plate',
  'truck.vin': 'Truck VIN',
  'driver1.name': 'Driver 1 name',
  'driver1.phone': 'Driver 1 phone',
  'driver1.licenseNumber': 'Driver 1 CDL',
  'driver2.name': 'Driver 2 name',
  'driver2.phone': 'Driver 2 phone',
  'driver2.licenseNumber': 'Driver 2 CDL',
  sealNumber: 'Seal #'
};
